<template>
    <Card class="layout-card" style="height: 100%;">
        <div style="display:flex;justify-content: space-between;margin-bottom: 10px;flex-shrink: 0;">
            <div class="search-form">
                <Input :maxlength="100" type="number" v-model="searchForm.playId" placeholder="请输入剧ID" />
                <Input :maxlength="100" v-model="searchForm.playName" placeholder="请输入中文剧名" />
                <Select v-model="searchForm.channel" placeholder="请选择渠道"  filterable clearable>
                    <Option :value="0">Facebook</Option>
                    <Option :value="1">TikTok</Option>
                    <Option :value="4">youtube</Option>
                    <Option :value="5">TikTok-运营</Option>
                </Select>
                <!-- <Select v-model="searchForm.androidTemplateId" placeholder="请选择安卓充值模板" filterable clearable>
                    <Option v-for="(item,index) in androidTempList" :value="item.id" :key="index">{{ item.templateName }}</Option>
                </Select>
                <Select v-model="searchForm.iosTemplateId" placeholder="请选择IOS充值模板" filterable clearable>
                  <Option v-for="(item,index) in iosTempList" :value="item.id" :key="index">{{ item.templateName }}</Option>
                </Select> -->
                <Select v-model="searchForm.status" placeholder="请选择状态" filterable clearable>
                  <Option :value="0">关闭</Option>
                  <Option :value="1">开启</Option>
                </Select>
                
                <DatePicker :editable="false" :value="listDate" format="yyyy-MM-dd" style="flex-shrink: 0;" type="daterange" placeholder="请选择日期" @on-change="getListDate" clearable></DatePicker>
                <Select v-model="searchForm.createUser" placeholder="请选择创建人" filterable clearable>
                  <Option v-for="(item,index) in userList" :value="item.userId" :key="index">{{ item.userName }}</Option>
                </Select>
                <Button type="primary" @click="getData()">查询</Button>
                <Button @click="handleReset()">重置</Button>
            </div>
            <div><Button type="primary" @click="handleOpenEditModal()">添加</Button></div>
        </div>
        <div style="height: 100%;overflow:auto">
        <Table :data="tableData" :columns="columns">
        <template #status="{row,index}">
          <i-switch :value="tableData[index].status" :before-change="()=>handleChangeStatus(row)" @on-change="row.status=$event"></i-switch>
          
        </template>
            <template #action="{row}">
                <div>
                    <a style="margin-left: 10px;"  @click="handleOpenEditModal(row)">编辑</a>
                    <a style="margin-left: 10px;"  @click="handleCopy(row,'copy')">复制</a>
                    <a style="margin-left: 10px;"  @click="handleCopy(row,'preview')">预览</a>
                    <a style="margin-left: 10px;color:#19be6b"  @click="handleCopy(row,'qrcode')">二维码</a>
                    <!-- <Poptip confirm title="确定要删除吗？" transfer @on-ok="handleDel(row)"><a style="margin-left: 10px;color: red">删除</a></Poptip> -->

                </div>
            </template>
            <Pages slot="footer" :page="page" :func="getData"></Pages>
        </Table>
        </div>

        <Modal v-model="editVisible" :title="(form.id?'编辑':'新增')+'推广链'">
            <Form @submit.native.prevent :label-width="120" :model="form" ref="formRef" v-if="editVisible">
                <FormItem label="链接名称：" prop="linkName" :rules="[{required:true,message:'请输入链接名称'}]">
                    <Input :maxlength="150" v-model="form.linkName" />
                </FormItem>
                <FormItem label="域名：" prop="domain" :rules="[{required:true,message:'请输入链接名称'}]">
                    <Input disabled v-model="form.domain" />
                </FormItem>
                <FormItem label="渠道：" prop="channel" :rules="[{required:true,message:'请选择渠道'}]">
                    <Select v-model="form.channel" placeholder="请选择渠道" @on-change="getPixel(['FACEBOOK','TIKTOK'][$event])">
                        <Option :value="0">Facebook</Option>
                        <Option :value="1">TikTok</Option>
                        <Option :value="4">YouTuBe</Option>
                        <Option :value="5">TikTok-运营</Option>
                    </Select>
                </FormItem>
                <FormItem label="归因方式：" prop="attributionMethod" :rules="[{required:true,message:'请选择归因方式'}]">
                    <Select v-model="form.attributionMethod" placeholder="请选择归因方式" >
                        <Option :value="0">AppFlys</Option>
                    </Select>
                </FormItem>
                <FormItem v-if="[0,1].includes(Number(form.channel))" label="pixel：" prop="pixel" :rules="[{required:true,message:'请选择pixel'}]">
                    <Select v-model="form.pixel" placeholder="请选择pixel" :disabled="form.channel!=0&&!form.channel">
                        <Option v-for="(item,index) in pixelList" :value="item.dictValue" :key="index">{{ item.dictName }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="剧ID：" prop="playId" :rules="[{required:true,message:'请输入剧ID'}]">
                    <Input type="number" v-model="form.playId" @on-blur="handlefindPlay" @on-focus="submitDisabled=true" @on-change="seriesLi=[]" />
                </FormItem>
                <FormItem label="剧集：" prop="seriesId">
                    <Select v-model="form.seriesId">
                      <Option v-for="(item,index) in seriesLi" :key="index" :value="item.id">
                        {{ item.seriesName }}(第{{ item.seriesNum }}集)
                      </Option>
                    </Select>
                </FormItem>
                <FormItem label="中文剧名：" prop="chinesePlayName">
                    <Input disabled v-model="form.chinesePlayName" placeholder="输入剧ID后自动匹配" />
                </FormItem>
                <FormItem label="翻译剧名：" prop="playName" :rules="[{required:true,message:'请匹配剧名'}]">
                    <Input disabled v-model="form.playName" placeholder="输入剧ID后自动匹配" />
                </FormItem>
                <FormItem label="付费卡点：" prop="stickingPoint" :rules="[{required:true,message:'请输入付费卡点'},{ validator: (rule, value, callback) => value < 2 ? callback('集数不能小于2') : callback() }]">
                    <InputNumber v-model="form.stickingPoint" :min="0" :max="seriesLi.length" :disabled="!!form.id||!form.playId" />
                </FormItem>
                <FormItem label="语言：" prop="languageId" :rules="[{required:true,message:'请选择语言'}]">
                    <Select v-model="form.languageId" placeholder="请选择语言" >
                      <Option v-for="(item,index) in langList" :value="item.langId" :key="index">{{ item.chineseLangName }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="样式：" prop="landingPageStyle" :rules="[{required:true,message:'请选择样式'}]">
                    <Select v-model="form.landingPageStyle" placeholder="请选择样式" >
                        <Option :value="0">样式一</Option>
                    </Select>
                </FormItem>
                <FormItem label="落地页海报：" prop="landingPagePoster">
                    <UploadFile :uploadList="form.landingPagePoster ? [form.landingPagePoster] : []" @hanldDel="form.landingPagePosterId = ''; form.landingPagePoster = ''"
                    @handleSuccess="form = { ...form, landingPagePosterId: $event.fileId, landingPagePoster: $event.fileUrl }">

                    </UploadFile>
                </FormItem>
                <FormItem label="落地页标题：" prop="landingPageTitle">
                    <Input v-model="form.landingPageTitle" placeholder="输入剧ID后自动匹配" :maxlength="150" />
                </FormItem>
                <FormItem label="落地页简介：" prop="landingPageDescription">
                    <Input v-model="form.landingPageDescription" placeholder="输入剧ID后自动匹配" type="textarea" :autosize="{minRows:3,maxRows:5}" show-word-limit :maxlength="1500"  />
                </FormItem>
                <FormItem label="跳转方式：" prop="redirectMethod" :rules="[{required:true,message:'请选择跳转方式'}]">
                    <Select v-model="form.redirectMethod" placeholder="请选择跳转方式" >
                        <Option :value="0">有感</Option>
                    </Select>
                </FormItem>
                <FormItem label="IOS充值模板：" prop="iosTemplateId">
                    <Select v-model="form.iosTemplateId" placeholder="请选择IOS充值模板" disabled >
                      <Option v-for="(item,index) in iosTempList" :value="item.id" :key="index">{{ item.templateName }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="安卓充值模板：" prop="androidTemplateId">
                    <Select v-model="form.androidTemplateId" placeholder="请选择安卓充值模板" disabled >
                      <Option v-for="(item,index) in androidTempList" :value="item.id" :key="index">{{ item.templateName }}</Option>
                    </Select>
                </FormItem>
                <FormItem label="状态" prop="status" :rules="[{required:true,message:'请选择'}]">
                  <i-switch v-model="form.status"></i-switch>
                </FormItem>
            </Form>
            <template #footer>
                <Button @click="editVisible=false">取消</Button>
                <Button type="primary" :loading="submitLoading" @click="handleSubmit()" :disabled="submitDisabled">提交</Button>
            </template>
        </Modal>
        <Modal v-model="showQrcode" title="二维码" width="400">
            <div ref="qrcodeContainer" style="display:flex;align-items: center;justify-content: center;"></div>
        </Modal>
    </Card>
</template>

<script>
import Pages from '@/components/pages'
import { getPlacementList, addPlacement, editPlacement, getPlacementInfo, getPlacementPlay, getPlacementUserList, getTempList, changePlacementStatus } from '@/api/landing'
import UploadFile from '@/components/Upload/uploadImg.vue'
import { getPlayInfo } from '@/api/play'
import { getSeriesList } from '@/api/series'
import {data} from './data'
import { getDictionaryList } from '@/api/dictionary'
import { copyText } from '../../../libs/util'
import QrCode from 'qrcodejs2'
export default {
  components: {
    Pages,
    UploadFile
  },
  data() {
    return {
      editVisible:false,
      submitDisabled:false,
      form:{
        domain: 'https://www.saros-tv.com',
        status: false
      },
      showQrcode: false,
      searchForm:{},
      submitLoading:false,
      listDate: [],
      langList: [],
      iosTempList: [],
      userList: [],
      androidTempList: [],
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      pixelList: [],
      tableData: [],
      columns: [
        {
          title: '链接编号',
          key: 'linkId',
          wdith: 100,
          tooltip: true,
          tooltipMaxWidth: 200,
        },
        {
          title: '链接名称',
          wdith: 130,
          tooltip: true,
          tooltipMaxWidth: 200,
          key: 'linkName'
        },
        {
          title: '域名',
          width: 120,
          key: 'domain'
        },
        {
          title: '渠道',
          wdith: 120,
          key: 'channel',
          render: (h,params)=>{
            return <div>
                {['Facebook','TikTok','' ,'' ,'YouTuBe','TikTok-运营'][params.row.channel]}
              </div>
          }
        },
        {
          title: '归因方式',
          wdith: 110,
          key: 'attributionMethod',
          render: (h,params)=>{
            return <div>
                {['AppFlys'][params.row.attributionMethod]}
              </div>
          }
        },
        {
          title: '剧ID',
          wdith: 60,
          key: 'playId'
        },
        
        {
          title: '中文剧名',
          wdith: 120,
          tooltip: true,
          tooltipMaxWidth: 200,
          key: 'chinesePlayName'
        },
        {
          title: '语言',
          wdith: 100,
          key: 'languageName'
        },
        {
          title: '付费卡点',
          wdith: 100,
          key: 'stickingPoint'
        },
        {
          title: '跳转方式',
          key: 'redirectMethod',
          width: 100,
          render: (h,params)=>{
            return <div>
                {['有感'][params.row.redirectMethod]}
              </div>
          }
        },
        {
          title: '像素',
          wdith: 150,
          key: 'pixelName',
          tooltip: true,
          tooltipMaxWidth: 200
        },
        // {
        //   title: '安卓充值模板',
        //   wdith: 180,
        //   key: 'androidTemplateName'
        // },
        // {
        //   title: 'IOS充值模板',
        //   wdith: 180,
        //   key: 'iosTemplateName'
        // },
        {
          title: '状态',
          key: 'status',
          width: 80,
          slot: 'status'
        },
        {
          title: '创建日期',
          wdith: 150,
          key: 'createTime'
        },
        {
          title: '创建人',
          width: 90,
          key: 'createUserName'
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          slot: 'action'
        }
      ],
      seriesLi: []
    }
  },
  computed:{
    buttonMenu() {
      const li = this.$store.getters.getMenuRules('system/Placement')
      const obj = {}
      li.forEach(i => {
        obj[i.menuPath] = true
      })
      return obj
    }
  },
  methods:{
    handleChangeStatus(row) {
      changePlacementStatus(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData(this.page.current)
      }).catch(e => {
        this.$Message.error('操作失败')
      })
      return new Promise(() => {})
    },
    handleCopy(row,type){
      const { domainFb, domainTt, fieldsFb, fieldsTt } = data
      let str = row.domain + ([domainFb,domainTt][row.channel]||'/landing/')
      if(row.languageCode=='ko_KR'){
        str+='kr'
      }else if(row.languageCode=='ja_JP'){
        str+='jp'
      }else if(row.languageCode=='es_ES'){
        str+='es'
      }else if(row.languageCode=='zh_TW'){
        str+='tw'
      }else if(row.languageCode=='th_TH'){
        str+='th'
      }else if(row.languageCode=='pt_PT'){
        str+='pt'
      }else if(row.languageCode=='id_ID'){
        str+='id'
      }else if(row.languageCode=='tr_TR'){
        str+='tr'
      }else if(row.languageCode=='ar_SA'){
        str+='ar'
      }else if(row.languageCode=='de_DE'){
        str+='de'
      }else if(row.languageCode=='fr_FR'){
        str+='fr'
      }
      str += `?linkId=${row.linkId}`
      // str += `&pl=${btoa(row.pixel)}`
      str += ([fieldsFb,fieldsTt][row.channel]||'')
      if(type=='copy'){
        copyText(str)
      }
      else if(type=='preview'){
        window.open(str,'_blank')
      }else if(type=='qrcode'){
        this.showQrcode = true
        this.$nextTick(()=>{
          const qrcodeContainer = this.$refs.qrcodeContainer
          qrcodeContainer.innerHTML = ''
          const qrcode = new QrCode(qrcodeContainer, {
            text: str,
            width: 300,
            height: 300,
            colorDark: "#000", //二维码颜色
            colorLight: "#fff" //二维码背景颜色
          })
        })
      }
      
    },
    async handlefindPlay(){
      this.submitDisabled = true
      
      if(!this.form.playId) return
      this.getSeries(this.form.playId)
      this.langList = []
      const r = await getPlacementPlay(this.form.playId)
        if(!r.data){
          this.$Message.error('未找到对应短剧')
          return
        }
        this.form = {
          status: false,
          ...this.form,
          playName: r.data.playName,
          chinesePlayName: r.data.chinesePlayName||'',
          stickingPoint: r.data.startNum+1||2,
          landingPagePosterId: r.data.landingPagePosterId,
          landingPagePoster: r.data.landingPagePoster,
          landingPageTitle: r.data.pageTitle,
          landingPageDescription: r.data.pageDescription,
        }
        this.langList = r.data.langList
        this.submitDisabled = false
    },
    getSeries(playId){
      getSeriesList({current: -1, size: -1, playId}).then(r=>{
        this.seriesLi = r.data.records
      })
    },
    getListDate(data) {
      this.listDate = data
      this.searchForm.beginDate = data[0]
      this.searchForm.endDate = data[1]
    },
    getData(page) {
      if (page) this.page.current = page
      else this.page.current = 1
      getPlacementList({
        ...this.page,
        ...this.searchForm,
        status: typeof this.searchForm.status == 'number' ? !!this.searchForm.status: null
      }).then(({ data }) => {
        console.log(data)

        this.tableData = data.records
        this.page.current = data.current
        this.page.total = data.total
      })
    },
    async handleOpenEditModal(row) {
      if (row) {
        this.form.playId = row.playId
        await this.handlefindPlay()
        this.getSeries(row.playId)
        const r = await getPlacementInfo(row.id)
        
        this.form = {
          ...r.data,
          stickingPoint: r.data.stickingPoint?r.data.stickingPoint: this.form.stickingPoint
        }
        this.getPixel(['FACEBOOK','TIKTOK'][r.data.channel])
        
        
      } else {
        this.langList = []
        this.form = {
          domain: 'https://www.saros-tv.com',
          stickingPoint: null
        }
      }
      this.editVisible = true
    },
    handleSubmit() {
      this.$refs.formRef.validate(r => {
        if (r) {
          const func = this.form.id ? editPlacement : addPlacement
          this.submitLoading = true
          func({
            ...this.form
          }).then(r => {
            this.$Message.success('操作成功')
            this.getData()
            this.submitLoading = false
            this.editVisible = false
          }).catch(() => {
            this.submitLoading = false
          })
        }
      })
    },
    handleDel(row) {
      delPlacement(row.id).then(r => {
        this.$Message.success('操作成功')
        this.getData()
      })
    },
    handleReset() {
      this.searchForm = {}
      this.listDate = []
    },
    handleGetTempList(){
      getTempList({
        current: 1,
        status: true,
        size: 1000, 
        templateChannel: 0,
        total: 0
      }).then(r=>{
        this.iosTempList = r.data.records
      })
      getTempList({
        current: 1,
        size: 1000, 
        status: true,
        templateChannel: 1,
        total: 0

      }).then(r=>{
        this.androidTempList = r.data.records
      })
    },
    getPixel(channel){
      this.pixelList = []
      getDictionaryList({dictTopic: `PIXEL_${channel}_TYPE`}).then(r=>{
        this.pixelList = r.data.records
      })
    },
    init(){
      this.handleGetTempList()
      getPlacementUserList().then(r=>{
        this.userList = r.data
      })
      
    }
  },
  mounted() {
    this.init()
    this.getData()
  }
}
</script>

<style scoped lang="less">
.search-form{
    display:flex;
    width: 90%;
    &>*{
        margin: 0 5px;
    }
}
.layout-card{
  /deep/ .ivu-card-body{
    height: 100%;display:flex;flex-direction: column;
  }
}
</style>
